module.exports = __webpack_public_path__ + "static/media/bunkey-avatar-08.b2669f67.png";